import {
  SOURCE_SMS,
  SOURCE_RCS,
  SOURCE_TCAPI,
  type LocationSources,
  SOURCE_ADMIN_SMS,
} from '@rsos/constants/locationSources';
import { RCS_ACCEPT_STATUS_ACCEPTED } from '@rsos/constants/rcsStatuses';
import useHasAccessToGoogleRCS from '@rsos/hooks/useHasAccessToGoogleRCS';
import { PhoneDetails, TextMessage } from './EmergencyCall.styles';

interface TextMessageStatusProps {
  isTT911?: boolean;
  source?: LocationSources;
  unreadTF911Message?: boolean;
  unreadRcsMessage?: boolean;
  isRcsAvailable?: boolean;
  rcsAcceptStatus?: number;
  isUnread?: boolean;
  isUnseen?: boolean;
  tt911Message?: string;
  rcsStatusText?: string;
  hasAgent511Access?: boolean;
}

const TextMessageStatus = ({
  isTT911,
  source,
  unreadTF911Message,
  unreadRcsMessage,
  isRcsAvailable,
  rcsAcceptStatus,
  isUnread,
  isUnseen,
  tt911Message,
  rcsStatusText,
  hasAgent511Access,
}: TextMessageStatusProps) => {
  const hasGoogleRCSAccess = useHasAccessToGoogleRCS();

  const validSources = new Set([
    SOURCE_RCS,
    SOURCE_SMS,
    SOURCE_TCAPI,
    SOURCE_ADMIN_SMS,
  ]);

  const isMessageSourceValid = (source && validSources.has(source)) || isTT911;

  const isRCSMessageShowable =
    !unreadRcsMessage ||
    isRcsAvailable ||
    (unreadRcsMessage && rcsAcceptStatus !== RCS_ACCEPT_STATUS_ACCEPTED);

  const canShowUnreadMessage = !unreadTF911Message && isRCSMessageShowable;

  const isMessageNotSeen = !(isUnread || isUnseen);

  const shouldShowAgentMessage = hasAgent511Access && tt911Message;

  const shouldShowRCSStatus = source === SOURCE_RCS && hasGoogleRCSAccess;

  const shouldShowAnything =
    isMessageSourceValid && canShowUnreadMessage && isMessageNotSeen;

  if (!shouldShowAnything) {
    return null;
  }

  if (shouldShowAgentMessage) {
    return <TextMessage>{tt911Message}</TextMessage>;
  } else if (shouldShowRCSStatus) {
    return <PhoneDetails>{rcsStatusText}</PhoneDetails>;
  } else if (source === SOURCE_ADMIN_SMS) {
    return <PhoneDetails>ADMIN LINE TEXT-TO-911</PhoneDetails>;
  }
  return <PhoneDetails>Text-to-911</PhoneDetails>;
};

export default TextMessageStatus;
